export interface SearchLendHistoriesRequest {
  searchFlag: LendHistorySearchFlag
  lendDate: string
  lendDateFrom: string
  lendDateTo: string
  lendBranchCode: string
}

export const LendHistorySearchFlag = {
  PrefixMatch: '1',
  RangeSpecification: '2'
} as const
export type LendHistorySearchFlag = typeof LendHistorySearchFlag[keyof typeof LendHistorySearchFlag]

export function SearchLendHistoriesRequestToJSON(
  value: SearchLendHistoriesRequest
): any {
  return {
    search_flag: value.searchFlag ? value.searchFlag : undefined,
    lend_date: value.lendDate !== '' ? value.lendDate : undefined,
    lend_date_from: value.lendDateFrom !== '' ? value.lendDateFrom : undefined,
    lend_date_to: value.lendDateTo !== '' ? value.lendDateTo : undefined,
    lend_branch_code:
      value.lendBranchCode !== '' ? value.lendBranchCode : undefined
  }
}
